import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35bd5536"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chooseTeam h-full flex flex-col" }
const _hoisted_2 = { class: "conten flex flex-col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择班组", -1))
const _hoisted_4 = { class: "content_list content-start scrollBar" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "team-name text-white font-medium title-text" }
const _hoisted_7 = { class: "people" }
const _hoisted_8 = {
  key: 0,
  class: "triangle"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://djcps.oss-cn-hangzhou.aliyuncs.com/pro/djmes/select.png",
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_12 = { class: "footer flex justify-between items-center w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: ($event: any) => (_ctx.chooseTeam(item)),
            style: _normalizeStyle(_ctx.activeIndedx == item.teamId && _ctx.LoginUserId == _ctx.userId ? _ctx.activeStyle : '')
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.teamName), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.userList), 1),
            (_ctx.activeIndedx == item.teamId && _ctx.LoginUserId == _ctx.userId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true)
          ], 12, _hoisted_5))
        }), 128)),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.$router.currentRoute.value.query && _ctx.$router.currentRoute.value.query.key == '2')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn cancle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, "取消"))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn cancle",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
          }, "上一步")),
      _createVNode(_component_a_button, {
        type: "primary",
        disabled: !(_ctx.tableList.length > 0 && _ctx.parmas.teamId),
        class: "btn next",
        onClick: _ctx.sure
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}